export const ECompanyInformationSection = {
  AGREEMENTS: "agreements",
  CANADIAN_PAYROLL_ONBOARDING: "canadian_payroll_onboarding",
} as const;

export type TCompanyInformationSection =
  (typeof ECompanyInformationSection)[keyof typeof ECompanyInformationSection];
